import store from '@/store';

export default function authRoute(to, from, next) {
  const requiresAuth = to.matched.some((route) => route.meta.requiresAuth);
  const { isLogged } = store.state.session;

  // Need to be logged
  if (requiresAuth && !isLogged) {
    next({
      name: 'login',
      params: { redirect: to.path },
    });
  } else {
    next();
  }
}
